// @flow
import { connect } from 'react-redux';

import { setViewport, setSelectedFeature } from 'actions/map';
import { showErrorMessage } from 'actions/errorMessage';
import { setFollowedAircraft, setFeatures } from 'actions/rt';

import RTOverlay from './RTOverlay';

const mapStateToProps = ({
  map: { selectedFeature, visibleAirspaces },
  rt: { followedAircraft, features },
  drawOverlay: { appInDrawMode },
}) => ({
  selectedFeature,
  followedAircraft,
  features,
  visibleAirspaces,
  appInDrawMode,
});

const mapDispatchToProps = {
  setViewport,
  showErrorMessage,
  setFollowedAircraft,
  setFeatures,
  setSelectedFeature,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RTOverlay);



// WEBPACK FOOTER //
// ./overlays/RTOverlay/index.js